import React from "react";
import {Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import {formatCurrency} from "../../utils/Utils";
import {QueryTransactionsTableDiv} from "./TransactionQueryStyles";
import {TableBodyStyle, TableHeaderStyle} from "../../styles/globalStyles";

export default ({
    transactions
}) => {

    return (
        <QueryTransactionsTableDiv>
            {transactions &&
                <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <TableHeaderStyle>Date</TableHeaderStyle>
                            </TableCell>
                            <TableCell>
                                <TableHeaderStyle>Transaction</TableHeaderStyle>
                            </TableCell>
                            <TableCell align="right">
                                <TableHeaderStyle>Amount</TableHeaderStyle>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {transactions.map((transaction) => (
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <TableBodyStyle>{transaction.date}</TableBodyStyle>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    <TableBodyStyle>{transaction.desc}</TableBodyStyle>
                                </TableCell>
                                <TableCell align="right">
                                    <TableBodyStyle>
                                        R {formatCurrency(parseFloat(transaction.amount).toFixed(2))}
                                    </TableBodyStyle>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            }
        </QueryTransactionsTableDiv>
    );
}